/**
 * The most-recently-OPENED product (shell nav memory, owner feedback
 * 2026-08-25; Stage A): written whenever a `/products/:pid/*` route is active,
 * persisted to localStorage, and read by the sidebar (so /products and
 * /settings keep the last product's switcher + session list) and by the
 * `/` redirect (landing on the last product's home).
 *
 * This is NAV memory only. The active product itself always derives from the
 * current route (AppShell matches the URL directly); this store never
 * overrides it.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { Ulid } from '../api/types';

export interface LastProductState {
  productId: Ulid | null;
  setLastProduct: (pid: Ulid) => void;
  /** Forget `pid` if it is the remembered product (product deleted). */
  clearLastProduct: (pid: Ulid) => void;
}

export const useLastProduct = create<LastProductState>()(
  persist(
    (set, get) => ({
      productId: null,
      setLastProduct(pid) {
        if (get().productId !== pid) set({ productId: pid });
      },
      clearLastProduct(pid) {
        if (get().productId === pid) set({ productId: null });
      },
    }),
    {
      name: 'loremap.lastProduct',
      version: 1,
      partialize: (s) => ({ productId: s.productId }),
    },
  ),
);
